export default __webpack_public_path__ + "static/media/534.3bd8c472.gif";